import * as v from 'valibot';

import { ENOPOrganType, EResourceStatus } from '#shared';

import type { CCSurgeon } from '../types';

export const surgeonSchema: v.GenericSchema<CCSurgeon> = v.object({
  id: v.string('Surgeon ID is missing'),
  hubId: v.nullable(v.string('Hub ID is missing')),
  regionId: v.nullable(v.string('Region ID is missing')),
  // Non-nullable since the NOP contract sync of 2026-07-16 (resourceservice
  // dropped `null` from SResource.organs). A lagging NOP deployment may still
  // send null — keep that a @WARNING instead of an ERROR that would drop the
  // surgeon from the UI. The surgeon is retained (with organs still null at
  // runtime) and the issue surfaces in validation metadata / System Monitor,
  // not in Sentry (only ERROR issues are sent there).
  organs: v.array(
    v.enum(
      ENOPOrganType,
      issue => `@WARNING: Unexpected organ type ${issue.input}`,
    ),
    '@WARNING: Organs missing or null (non-nullable per contract)',
  ),
  status: v.enum(
    EResourceStatus,
    issue => `@WARNING: Unexpected status ${issue.input}`,
  ),
  timezone: v.nullable(v.string('Timezone is missing')),
});
